import React,  { useContext, useEffect, useState, useCallback, } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Footer } from '../../Component/Footer/Footer';
import { Header } from '../../Component/Header/Header';
import { Recommend } from '../../Component/Recommend/Recommend';
import { ARROW_STYLE, POINT_STYLE, Swiper } from '../../Component/Swiper/Swiper';
import { fetchData } from '../../Utils/fetch';
import { imageDomain, STYLE_TYPE } from '../../Utils/magicStrings';
import { styleContextApp } from '../StyleContext';
import { ContentBlockWrapper,
     DetailTitle, DetailSubtitle,
      ContentPictureWrapper, ContentSubtitle, ContentMain, 
      DetailCatelogWrapper, DetailItems, ReserveButton,
      ToReserveButton, ReturnButton, PlanButtonWrapper
    } from '../Detail/DetailStyle';
import topBig from '../Home/BigTop.png';
import topSmall from '../Home/SmallTop.png';
import { ReserveTeleWrapper, WechatWindow } from '../Reserve/ReserveStyle';
import { Modal } from '../../Component/Modal/Modal';
import wechat from '../Reserve/wechat.png';


export function Plan(props) {
    const { id } = useParams();
    const [ content, setContent ] = useState(null);
    const styleType = useContext(styleContextApp);
    const getContentInfo = useCallback( async (id) => {
        
        if(id) {
            try {
                const data = await fetchData(`inn/${id}`);
                const innPlanData = data?.innPlanList.filter(e => e.type === 2);
                if(innPlanData) {
                    const {imgUrl, innPlanSectionDtoList} = innPlanData[0];
                    const content = {
                        ...innPlanData[0],
                        coverImgUrl: imgUrl,
                        innSectionDtoList: innPlanSectionDtoList,
                    }
                    setContent(content);
                }
                
            } catch(e) {
                console.log(e);
            }
        } 
    }, []);
    
    useEffect(() => {
            getContentInfo(id);
        window.scrollTo(0,0);
    }, [getContentInfo, id]);

    //
    if(!content) return null;
    return (
        <div>
            <div className='before'>
                <Header hasMarginTop={false} title={content.title} styleType={styleType} pictures={[`${imageDomain}/${content.coverImgUrl}`]} headerHeight={584} mobileHeight={404}/>
                <div style={{width: 'min(1440px, 100vw)', margin: 'auto'}}>
                <DetailTitle styleType={styleType}>
                    {content.name}
                </DetailTitle>
                <DetailSubtitle styleType={styleType}>
                    {content.title}
                </DetailSubtitle>
                </div>
            </div>
            <div style={{width: 'min(1440px, 100vw)', margin: 'auto'}}>
            {content?.innSectionDtoList?.map((contentInfo, index) => (
                <ContentBlock contentInfo={contentInfo} key={contentInfo.title} index={index} styleType={styleType}/>
            ))}
            <DetailCatelog styleType={styleType} items={content.innSectionDtoList.map(e => e.title)}/>
            {styleType !== STYLE_TYPE.MOBILE && <ReserveButtonItem styleType={styleType} id={id} />}
            {<PlanBlock styleType={styleType} id={id} />}
            <Recommend styleType={styleType} recommendItem={content.recommendList} />
            </div>
            <Footer styleType={styleType}></Footer>
        </div>
    );
};

const PlanBlock = ({styleType, id}) => {
    return (
        <PlanButtonWrapper styleType={styleType}>
            <Link to={`/detail/${id}`}>
                <ReturnButton styleType={styleType}>返回詳情頁</ReturnButton>
            </Link>
            <Link to={`/reserve/${id}`}>
                <ToReserveButton styleType={styleType}>預訂此推薦行程</ToReserveButton>
            </Link>
        </PlanButtonWrapper>
    )
}

const ContentBlock = ({contentInfo, styleType, index}) => {
    const pictureElement = () => {
        const { imgUrlList }  = contentInfo; 
        if(!imgUrlList || !Array.isArray(imgUrlList) ||imgUrlList.length === 0) {
            return null;
        } else if (imgUrlList.length === 1) {
            return (
                <ContentPictureWrapper styleType={styleType} picType={1}>
                    <img data-src={`${imageDomain}/${imgUrlList[0]}`} alt='' className='lazyload'/>
                </ContentPictureWrapper>
            );
        } else if (imgUrlList.length === 4) {
            return (
                <ContentPictureWrapper styleType={styleType} picType={4}>
                    {imgUrlList.map((pic, i) => (
                        <div key={i}>
                            <img data-src={`${imageDomain}/${pic}`} alt='' className='lazyload' />
                        </div>
                    ))}
                </ContentPictureWrapper>
            );
        } else {
            const picElement = imgUrlList.map(pic => (
                <img data-src={`${imageDomain}/${pic}`} key={pic} alt='' className='lazyload' style={{width: '100%', height: '100%'}} />
            ));
            return (
                <ContentPictureWrapper styleType={styleType} picType={5}>
                    {
                        <Swiper 
                            height={styleType === STYLE_TYPE.MOBILE ? 210 : 411} 
                            isAutoPlay={false} 
                            pointStyle={styleType === STYLE_TYPE.MOBILE ? POINT_STYLE.NONE :POINT_STYLE.POINT_2} 
                            arrowStyle={styleType === STYLE_TYPE.MOBILE ? ARROW_STYLE.WHITE_CIRCLE_3 :ARROW_STYLE.BIG_CIRCLE_2}  
                            elements={picElement} 
                            isLoop={true} 
                            hasArrow={false}
                        />
                    }
                </ContentPictureWrapper>
            ) ;
        }
    };

    return (
        <ContentBlockWrapper  styleType={styleType} className='content_block' id={`content_${index}`}>
            <ContentSubtitle styleType={styleType}>
                {contentInfo.title}
            </ContentSubtitle>
            <ContentMain styleType={styleType}>
                {contentInfo.content}
            </ContentMain>
            {pictureElement()}
        </ContentBlockWrapper>
    )
};

const DetailCatelog = ({items, styleType}) => {
    const [ nowPostion, setNowPosition ] = useState(0);
    const [ fixContent, setFixContent ] = useState(false);
    const [ hide, setHide ] = useState(false);
    const { id } = useParams();
    useEffect(() => {
        var intersectionObserver = new IntersectionObserver(function(entries) {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio <= 0) setHide(false);
            else setHide(true);
          });
          // start observing
          const element = document.querySelector('#footer');
          element && intersectionObserver.observe(element);
          return () => {
            element && intersectionObserver.unobserve(element);
          }
    }, []);
    
    useEffect(() => {
        if(!items) return;
        const allBlock = document.getElementsByClassName('content_block');
        let position =  document.getElementsByClassName('before')[0].getBoundingClientRect().height;

        const blockPosition = Array.from(allBlock).map((now, index) => {
            let last = position;
            position += now.getBoundingClientRect().height;
            return last;
        });

        const scrollListen = (e) => {
            let scrollTop = document.documentElement.scrollTop;
            //计算头图的高度.
            setFixContent(scrollTop > document.getElementById('header')?.offsetHeight);
            for(let i = 0; i < blockPosition.length; i++) {
                if(scrollTop < blockPosition[i]) {setNowPosition(i-1);break;}
            }
        }
        scrollListen();
        document.addEventListener('scroll', scrollListen);
        return () => {
            document.removeEventListener('scroll', scrollListen);
        }
    }, [items]);
    if(hide) return null;
    const length = styleType === STYLE_TYPE.MOBILE ? 5 : 10;
    return(
        <DetailCatelogWrapper styleType={styleType} needFixed={fixContent}>
            {items.map((item, index) => (
                <DetailItems href={`#content_${index}`}key={item} styleType={styleType} id={index} highlight={index === nowPostion} onClick={() => {
                    setNowPosition(index);                 
                      //document.documentElement.scrollTop = document.getElementById(`content_${index}`).getBoundingClientRect().y + window.scrollY;
                }}>{item.substring(0,length)}</DetailItems>
            ))}
            {styleType === STYLE_TYPE.MOBILE && <ReserveButtonItem styleType={styleType} id={id} />}
        </DetailCatelogWrapper>
    )
};

const ReserveButtonItem = ({styleType, id}) => {
    const [ hide, setHide ] = useState(false);
    useEffect(() => {
        if(styleType !== STYLE_TYPE.MOBILE) {
            var intersectionObserver = new IntersectionObserver(function(entries) {
                // If intersectionRatio is 0, the target is out of view
                // and we do not need to do anything.
                if (entries[0].intersectionRatio <= 0) setHide(false);
                else setHide(true);
              });
              const element = document.querySelector('#recommend');
              element && intersectionObserver.observe(element);
              // start observing
              return () => {
                element && intersectionObserver.unobserve(element);
              }
        }
    }, [styleType]);
    if(hide) return null;
    return (
        <Link to={`/reserve/${id}`}>
            <ReserveButton styleType={styleType}>{styleType === STYLE_TYPE.MOBILE ? '現在預訂' : '咨詢・預約'}</ReserveButton>
        </Link>
    )
}

